import { useNavigate } from "react-router-dom";
import { track } from "@amplitude/analytics-browser";
import ResponsiveCDNImage from "../../../components/common/image/responsive-cdn-image";
import type { GetReviewByStoreIdQuery } from "../../../__generated__/graphql";

type PackReviewItem = GetReviewByStoreIdQuery["getReviewByStoreId"][number];

interface ReserveReviewGridProps {
  packReviews: PackReviewItem[];
  storeId: number | undefined;
  onReviewSelect: (review: PackReviewItem) => void;
}

const ReserveReviewGrid = ({
  packReviews,
  storeId,
  onReviewSelect,
}: ReserveReviewGridProps) => {
  const navigate = useNavigate();

  if (packReviews.length === 0) return null;

  return (
    <div className="px-5 pb-6">
      <div className="text-sm font-semibold text-gray-500 mb-3">
        랜덤박스 미리보기
      </div>
      <div className="grid grid-cols-3 gap-1.5">
        {packReviews.slice(0, 9).map((review, index) => {
          const isLast = index === 8 && packReviews.length > 9;
          return (
            <div
              key={review.id}
              className="aspect-square rounded-lg overflow-hidden bg-gray-100 cursor-pointer relative"
              onClick={() => {
                if (isLast) {
                  track("매장 페이지 예약리뷰 더보기 클릭");
                  if (storeId) navigate(`/store/${storeId}/review`);
                } else {
                  onReviewSelect(review);
                }
              }}
            >
              <ResponsiveCDNImage
                src={review.reviewImages?.[0]?.img || ""}
                alt="예약 리뷰"
                className="w-full h-full object-cover"
                sizeRatio={0.33}
              />
              {isLast && (
                <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-10">
                  <span className="text-white text-sm font-bold">더보기</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReserveReviewGrid;
